import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTermDepositInfoService,
  fetchTermDepositMaturityService,
  fetchTermDepositOpenAuthService,
  fetchTermDepositOpenCheckCodeService,
  fetchTermDepositOpenConfirmService,
  fetchTermDepositOpenCreateService,
  fetchTermDepositPromotionsService,
  fetchTermDepositTermService,
} from "../services/term-deposit-open.service";
import {
  fetchTermDepositInfoFailure,
  fetchTermDepositInfoSuccess,
  fetchTermDepositMaturityFailure,
  fetchTermDepositMaturitySuccess,
  fetchTermDepositOpenAuthorizationFailure,
  fetchTermDepositOpenAuthorizationSuccess,
  fetchTermDepositOpenConfirmFailure,
  fetchTermDepositOpenConfirmSuccess,
  fetchTermDepositOpenCreateFailure,
  fetchTermDepositOpenCreateSuccess,
  fetchTermDepositPromoCodeFailure,
  fetchTermDepositPromoCodeSuccess,
  fetchTermDepositPromotionsFailure,
  fetchTermDepositPromotionsSuccess,
  fetchTermDepositTermFailure,
  fetchTermDepositTermSuccess,
} from "./actions";
import {
  FETCH_TERM_DEPOSIT_INFO_REQUEST,
  FETCH_TERM_DEPOSIT_MATURITY_REQUEST,
  FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_OPEN_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_OPEN_CREATE_REQUEST,
  FETCH_TERM_DEPOSIT_PROMOTIONS_REQUEST,
  FETCH_TERM_DEPOSIT_PROMO_CODE_REQUEST,
  FETCH_TERM_DEPOSIT_TERM_REQUEST,
} from "./actions.type";
import {
  FetchTermDepositMaturityRequest,
  FetchTermDepositOpenAuthorizationRequest,
  FetchTermDepositOpenConfirmRequest,
  FetchTermDepositOpenCreateRequest,
  FetchTermDepositPromoCodeRequest,
  FetchTermDepositPromotionsRequest,
  FetchTermDepositTermRequest,
} from "./types";

function* fetchTermDepositInfoSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTermDepositInfoService);
    console.log("fetchTermDepositInfo response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositInfoSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositInfoFailure(msg));
  }
}

function* fetchTermDepositTermSaga(action: FetchTermDepositTermRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositTermService(action));
    console.log("fetchTermDepositTerm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositTermSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositTermFailure(msg));
  }
}

function* fetchTermDepositMaturitySaga(action: FetchTermDepositMaturityRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositMaturityService(action));
    console.log("fetchTermDepositMaturity response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositMaturitySuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositMaturityFailure(msg));
  }
}

function* fetchTermDepositOpenCheckCodeSaga(action: FetchTermDepositPromoCodeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositOpenCheckCodeService(action));
    console.log("fetchTermDepositOpenCheckCode response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositPromoCodeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositPromoCodeFailure(msg));
  }
}

function* fetchTermDepositOpenCreateSaga(action: FetchTermDepositOpenCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositOpenCreateService(action));
    console.log("fetchTermDepositOpenCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositOpenCreateSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositOpenCreateFailure(msg));
  }
}

function* fetchTermDepositOpenConfirmSaga(action: FetchTermDepositOpenConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositOpenConfirmService(action));
    console.log("fetchTermDepositOpenConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositOpenConfirmSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchTermDepositOpenConfirmFailure());
    getErrorMessage(e, true);
  }
}

function* fetchTermDepositOpenAuthSaga(action: FetchTermDepositOpenAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositOpenAuthService(action));
    console.log("fetchTermDepositOpenAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositOpenAuthorizationSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositOpenAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* fetchTermDepositPromotionsSaga(action: FetchTermDepositPromotionsRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositPromotionsService(action));
    console.log("fetchTermDepositPromotions response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositPromotionsSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchTermDepositPromotionsFailure());
    getErrorMessage(e, true);
  }
}

function* termDepositOpenSaga() {
  yield all([
    takeLatest(FETCH_TERM_DEPOSIT_INFO_REQUEST, fetchTermDepositInfoSaga),
    takeLatest(FETCH_TERM_DEPOSIT_TERM_REQUEST, fetchTermDepositTermSaga),
    takeLatest(FETCH_TERM_DEPOSIT_MATURITY_REQUEST, fetchTermDepositMaturitySaga),
    takeLatest(FETCH_TERM_DEPOSIT_PROMO_CODE_REQUEST, fetchTermDepositOpenCheckCodeSaga),
    takeLatest(FETCH_TERM_DEPOSIT_OPEN_CREATE_REQUEST, fetchTermDepositOpenCreateSaga),
    takeLatest(FETCH_TERM_DEPOSIT_OPEN_CONFIRM_REQUEST, fetchTermDepositOpenConfirmSaga),
    takeLatest(FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_REQUEST, fetchTermDepositOpenAuthSaga),
    takeLatest(FETCH_TERM_DEPOSIT_PROMOTIONS_REQUEST, fetchTermDepositPromotionsSaga),
  ]);
}

export default termDepositOpenSaga;
